import { PeopleAlt } from "@mui/icons-material";
import { FormattedMessage } from "react-intl";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { NavUser } from "utils/asset";

const Icon = ({ src, alt }) => <LazyLoadImage src={src} alt={alt} width="16" />;

// ==============================|| MENU ITEMS - PAGES ||============================== //

const adminPages = {
  id: "admin-group-pages",
  title: <FormattedMessage id="admin settings" />,
  type: "group",
  children: [
    {
      id: "roles",
      title: <FormattedMessage id="roles" />,
      type: "item",
      url: "/roles",
      icon: () => <PeopleAlt sx={{ fontSize: 18 }} />,
      subject: "Role",
    },
    {
      id: "permissions",
      title: <FormattedMessage id="permissions" />,
      type: "item",
      url: "/permissions",
      icon: () => <Icon src={NavUser} alt="invoice icon" />,
      subject: "Permission",
    },
    // {
    //   id: "companies",
    //   title: <FormattedMessage id="Companies" />,
    //   type: "item",
    //   url: "/companny",
    //   icon: () => <Icon src={NavUser} alt="invoice icon" />,
    //   subject: "Company",
    // },
  ],
};

export default adminPages;
